import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var InfoSVG = function InfoSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm-.09 7.66a1.53 1.53 0 11-1.53 1.53 1.5 1.5 0 011.53-1.53zm2.44 12.68h-4.7a1.23 1.23 0 110-2.45h1.26v-3.41h-1.07a1.23 1.23 0 110-2.45h2.37a1.15 1.15 0 011.25 1.23v4.63h.89a1.23 1.23 0 110 2.45z"
  }));
};
InfoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InfoSVG);